import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ItemTrackerListComponent } from './item-tracker-list/item-tracker-list.component';

const routes: Routes = [
  { path: 'overview', component: ItemTrackerListComponent },
  { path: '', pathMatch: 'full', redirectTo: 'overview' }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ItemTrackerRoutingModule { }
